import { render, staticRenderFns } from "./inspection-status.vue?vue&type=template&id=17aff2b7&scoped=true"
import script from "./inspection-status.vue?vue&type=script&lang=js"
export * from "./inspection-status.vue?vue&type=script&lang=js"
import style0 from "./inspection-status.vue?vue&type=style&index=0&id=17aff2b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aff2b7",
  null
  
)

export default component.exports